<template>
<div class="card card-stats">
  <div :class="['card-header', gradientSwitcher(loggedRoleType)]">
    <i :class="[icon, 'stats-m-i']"/>
  </div>
  <div class="card-content">
    <p class="category">{{title}}</p>
    <h3 class="title">{{value}}</h3>
  </div>
  <div class="card-footer" v-if="partials.length> 0" >
    <div class="stats">
      <div v-for="(partial, index) in partials" :key="index" style="margin-right:10px">
        <i :class="partial.icon"/><span class="value"> {{ partial.value }}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import gradientSwitcher from '@/mixins/GradientSwitcher'
import { mapState } from 'vuex'

export default {
  name: 'stats-small-card',
  mixins: [gradientSwitcher],
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    partials: {
      type: Array
    }
  },
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  computed: {
    ...mapState({
      loggedRoleType: state => state.user.loggedRole.type
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

i {
  color: $grey;
}

.card-header {
  width: 57px;
  height: 57px;
  padding: 12px !important;
}

.card-stats .card-header i {
  font-size: 23px;
  line-height: 33px;
  width: 33px;
  height: 33px;
}

.card-stats .card-content {
  text-align: right;
  padding: 17px 17px 8px 17px;
}

.category {
  padding-bottom: 27px;
  line-height: 14px;
}

.title {
  @include biggestFontSize();
  line-height: 21px;
  letter-spacing: 1.05px;
}

.stats-m-i {
  color: white;
  @include smallFontSize();
}

.card-footer .material-icons {
  color: $grey;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/StatsSmallCard.vue